import React from 'react';

function Realtor() {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="15" 
            height="16" 
            viewBox="0 0 15 16" 
            fill="none"
        >
            <path 
                d="M15 8.43314L7.5075 0L0 8.43314H2.28975V16H12.7147V8.43314H15Z" 
                fill="#D92228"
            />
            <path 
                d="M10.411 6.13269C10.2148 5.91472 9.89994 5.79492 9.52094 5.79492C8.89573 5.79492 8.50255 6.08361 8.23173 6.33486L8.22651 6.33985C7.95643 6.62937 7.64606 7.02205 7.39091 7.78661L7.40583 7.00624C7.41553 6.58028 7.42075 6.21506 7.42075 6.17096C7.42075 6.07862 7.36107 5.97961 7.23274 5.97961H4.80801V6.20923L4.87143 6.21506C5.06839 6.23169 5.25566 6.25333 5.42725 6.38976C5.5802 6.50374 5.67346 6.66181 5.7033 6.86398C5.75254 7.09858 5.75254 7.78661 5.75254 8.08112V11.983C5.75254 12.3806 5.74209 12.9264 5.68838 13.2916C5.5899 13.6468 5.48694 13.7558 5.27505 13.8756C5.13742 13.9419 4.99148 13.9843 4.84233 14.0013L4.77295 14.0071V14.2359H8.39437V14.0071L8.33021 14.0013C8.19131 13.9909 8.05504 13.954 7.92733 13.8923C7.81841 13.849 7.72515 13.7392 7.62667 13.5379C7.48417 13.1993 7.39539 12.8174 7.39539 11.8898V10.2625C7.39539 9.77163 7.41553 9.29742 7.4297 9.08944C7.59235 7.7916 8.22725 6.74833 8.63983 6.74833C8.79725 6.74833 8.90095 6.93968 9.01436 7.24501C9.14716 7.59443 9.33367 7.96547 9.8701 7.96547C10.4013 7.96547 10.6818 7.4688 10.6818 6.97213C10.687 6.63436 10.5983 6.36148 10.411 6.13186V6.13269Z" 
                fill="white"
            />
        </svg>
    )
};

export default Realtor;